import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { Driver, driverSchema } from '../schemas/driver.schema';

/**
 * Creates Drivers
 * @param drivers The Drivers being created
 * @returns Data Object containing the created Drivers
 */
export function putDriversUpdateByIds(
  this: unknown,
  drivers: Partial<Driver>[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).driversUpdateByIdsUrl, {
        method: 'PUT',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(drivers),
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(driverSchema.omit({ modifiedOn: true })),
        message: z.string().nullable(),
      })
    )
  );
}
